import { BancaNovaResponse, ButtonState } from '../../../model/banca/BancasNovaResponse';
import { ButtonConfig, ButtonState as LocalButtonState } from './bancaButtonUtils';

export const getButtonConfigFromBackend = (
  banca: BancaNovaResponse,
  buttonType: 'sala' | 'data' | 'composicao' | 'convocar' | 'emergencia' | 'ata' | 'visualizar' | 'vincular' | 'enviarTermos' | 'recursos' | 'cancelar' | 'fechar' | 'finalizar' | 'abrirIntegracao' | 'finalizarIntegracao' | 'consultarBanca' | 'definirBanca'
): ButtonConfig => {
  const buttonMap = {
    sala: banca.botoes.salaDaBancaButton,
    data: banca.botoes.dataDaBancaButton,
    composicao: banca.botoes.composicaoBancaButton,
    consultarBanca: banca.botoes.composicaoBancaButton.consultarBancaButton,
    definirBanca: banca.botoes.composicaoBancaButton.definirBancaButton,
    convocar: banca.botoes.convocarBancaButton,
    emergencia: banca.botoes.emergenciaButton,
    ata: banca.botoes.ataButton,
    visualizar: banca.botoes.visualizarCandidatosButton,
    vincular: banca.botoes.vincularCandidatosButton,
    enviarTermos: banca.botoes.enviarTermosButton,
    recursos: banca.botoes.recursosButton,
    cancelar: banca.botoes.cancelarButton,
    fechar: banca.botoes.fecharButton,
    finalizar: banca.botoes.finalizarButton,
    abrirIntegracao: banca.botoes.abrirIntegracaoButton,
    finalizarIntegracao: banca.botoes.finalizarIntegracaoButton
  };

  const backendConfig: ButtonState = buttonMap[buttonType];

  if (!backendConfig.isVisible) {
    return { state: LocalButtonState.HIDDEN, title: '', icon: '', backgroundColor: '' };
  }

  const getButtonDetails = (type: string) => {
    switch (type) {
      case 'sala':
        return { title: 'Definir Sala da Banca', icon: '🔗', backgroundColor: 'white' };
      case 'data':
        return { title: 'Definir Data da Banca', icon: '📅', backgroundColor: '#ffeb99' };
      case 'composicao':
        return { title: 'Composição da Banca', icon: '👥', backgroundColor: '#cc99ff' };
      case 'consultarBanca':
        return { title: 'Consultar Disponibilidade', icon: '👤', backgroundColor: '#212529' };
      case 'definirBanca':
        return { title: 'Definição de Membros', icon: '📋', backgroundColor: '#212529' };
      case 'convocar':
        return { title: 'Convocar Banca', icon: '📢', backgroundColor: '#ffb366' };
      case 'emergencia':
        return { title: 'Inserção de Emergência', icon: '⚠️', backgroundColor: '#dc3545' };
      case 'ata':
        return { title: 'Baixar Ata da Banca', icon: '📄', backgroundColor: '#66cc99' };
      case 'visualizar':
        return { title: 'Visualizar Candidatos', icon: '👁', backgroundColor: '#f8f9fa' };
      case 'vincular':
        return { title: 'Vincular Candidatos', icon: '👥', backgroundColor: '#f8f9fa' };
      case 'enviarTermos':
        return { title: 'Enviar Termos', icon: '', backgroundColor: '#d1ecf1' };
      case 'recursos':
        return { title: 'Recursos', icon: '⚖️', backgroundColor: '#f8f9fa' };
      case 'cancelar':
        return { title: 'Cancelar Banca', icon: '✕', backgroundColor: '#f8d7da' };
      case 'fechar':
        return { title: 'Fechar Banca', icon: '⊖', backgroundColor: '#d4edda' };
      case 'finalizar':
        return { title: 'Finalizar Banca', icon: '✓', backgroundColor: '#fff3cd' };
      case 'abrirIntegracao':
        return { title: 'Abrir Integração', icon: '⇄', backgroundColor: '#cfe2ff' };
      case 'finalizarIntegracao':
        return { title: 'Concluir Integração', icon: 'BsGear + BsArrowLeftRight + BsGear', backgroundColor: '#d1ecf1' };
      default:
        return { title: '', icon: '', backgroundColor: '' };
    }
  };

  const details = getButtonDetails(buttonType);

  let state = LocalButtonState.ENABLED;
  let backgroundColor = details.backgroundColor;

  // Verificar completed primeiro, mas respeitar enabled
  if (backendConfig.isCompleted) {
    state = LocalButtonState.SUCCESS;
  } else if (backendConfig.isHalfCompleted) {
    state = LocalButtonState.WARNING;
  } else if (!backendConfig.isEnabled) {
    state = LocalButtonState.DISABLED;
  }

  // Cor de fundo cinza apenas quando desabilitado E não completado
  if (!backendConfig.isEnabled && !backendConfig.isCompleted && !backendConfig.isHalfCompleted) {
    backgroundColor = '#e9ecef';
  }

  // Se não está enabled mas está completed, manter SUCCESS mas desabilitar clique
  if (!backendConfig.isEnabled && (backendConfig.isCompleted || backendConfig.isHalfCompleted)) {
    // Manter o estado visual (SUCCESS/WARNING) mas será tratado como disabled no ActionButton
  }



  return {
    state,
    title: !backendConfig.isEnabled && (backendConfig.isCompleted || backendConfig.isHalfCompleted)
      ? details.title + ' DISABLED'
      : details.title,
    icon: details.icon,
    backgroundColor
  };
};

export const shouldShowColumnFromBackend = (
  bancas: BancaNovaResponse[],
  buttonType: 'cancelar' | 'fechar' | 'finalizar' | 'abrirIntegracao' | 'finalizarIntegracao'
): boolean => {
  const buttonMap = {
    cancelar: (banca: BancaNovaResponse) => banca.botoes.cancelarButton,
    fechar: (banca: BancaNovaResponse) => banca.botoes.fecharButton,
    finalizar: (banca: BancaNovaResponse) => banca.botoes.finalizarButton,
    abrirIntegracao: (banca: BancaNovaResponse) => banca.botoes.abrirIntegracaoButton,
    finalizarIntegracao: (banca: BancaNovaResponse) => banca.botoes.finalizarIntegracaoButton
  };

  return bancas.some(banca => buttonMap[buttonType](banca).isVisible);
};

// Mantém a lógica de visibilidade de colunas no frontend
export const shouldShowColumnFrontend = (
  bancas: BancaNovaResponse[],
  buttonType: 'cancelar' | 'fechar' | 'finalizar' | 'abrirIntegracao' | 'finalizarIntegracao'
): boolean => {
  return bancas.some(banca => {
    switch (buttonType) {
      case 'cancelar':
        return banca.botoes.cancelarButton.isVisible;
      case 'fechar':
        return banca.botoes.fecharButton.isVisible;
      case 'finalizar':
        return banca.botoes.finalizarButton.isVisible;
      case 'abrirIntegracao':
        return banca.botoes.abrirIntegracaoButton.isVisible;
      case 'finalizarIntegracao':
        return banca.botoes.finalizarIntegracaoButton.isVisible;
      default:
        return false;
    }
  });
};

// Verifica se a coluna de candidatos deve ser exibida
export const shouldShowCandidatosColumn = (bancas: BancaNovaResponse[]): boolean => {
  return bancas.some(banca =>
    banca.botoes.visualizarCandidatosButton.isVisible ||
    banca.botoes.vincularCandidatosButton.isVisible
  );
};